import { render, staticRenderFns } from "./approval-remark-dialog.vue?vue&type=template&id=763269ae&scoped=true&"
import script from "./approval-remark-dialog.vue?vue&type=script&lang=js&"
export * from "./approval-remark-dialog.vue?vue&type=script&lang=js&"
import style0 from "./approval-remark-dialog.vue?vue&type=style&index=0&id=763269ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763269ae",
  null
  
)

export default component.exports